import { ViewModeSelector } from "@/Components/v2/molecule/ViewModeSelector/ViewModeSelector";

import { CURVE_INFO_MAP, CurveType } from "../../constants/maps";
import { useInvestmentLevelsStore } from "../../store/useInvestmentLevelsStore";
import { useConfig } from "@/hooks/useConfig";

export const CurveTypeSelector = () => {
  const { curveType } = useInvestmentLevelsStore((state) => state.curves);
  const { setCurveType } = useInvestmentLevelsStore();
  const {
    config: { showReturnInsteadOfRevenue },
  } = useConfig();

  const options = Object.values(CurveType).map((type) => ({
    value: type,
    label: CURVE_INFO_MAP[type].label,
    description: CURVE_INFO_MAP[type].description,
  }));
  if (showReturnInsteadOfRevenue) {
    options.find((option) => option.value === CurveType.REVENUE)!.label = "Return";
    let description = options.find((option) => option.value === CurveType.REVENUE)!.description;
    description = description.replace("Revenue", "Return").replace("revenue", "return");
    options.find((option) => option.value === CurveType.REVENUE)!.description = description;
  }

  return (
    <ViewModeSelector
      value={curveType}
      options={options}
      onChange={(value) => setCurveType(value as CurveType)}
    />
  );
};
